import React, { useEffect } from 'react';
import Header from '../../components/header/Header';

const APropos = () => {
    // Force le fond sombre sur le body HTML pour annuler tout CSS global blanc
    useEffect(() => {
        document.body.style.backgroundColor = '#0f2027';
        document.body.style.color = '#ffffff';
        return () => {
            document.body.style.backgroundColor = '';
            document.body.style.color = '';
        };
    }, []);

    const skillCategories = [
    { title: 'Front-end', skills: ['React', 'JavaScript', 'HTML', 'CSS'] },
    { title: 'Back-end', skills: ['Node.js', 'Express', 'JWT', 'REST API'] },
    { title: 'Base de données', skills: ['MongoDB', 'Mongoose'] },
    { title: 'Outils', skills: ['VS Code', 'Postman'] },
    { title: 'Déploiement', skills: ['Hébergement de sites', 'Création nom de domaine', 'Configuration serveur'] },
];

    const workflowSteps = [
        'Analyse du besoin',
        'Conception de la base de données',
        "Création de l'API",
        'Développement React',
        'Tests',
        'Amélioration continue',
    ];

    const contributions = [
        "Développement d'applications MERN",
        "Conception d'API REST",
        'Interfaces React responsives',
        'Architecture MVC',
        'Intégration MongoDB',
        "Maintenance et évolution d'applications",
    ];

    const allTechnologies = [
        'React', 'Node.js', 'Express', 'MongoDB', 'Mongoose', 
        'JWT', 'Axios', 'REST API', 'HTML', 'CSS', 'JavaScript'
    ];

    const mainProjects = [
    {
        name: 'PokéWarm',
        desc: "Application web dédiée à l'univers Pokémon, développée avec React et JavaScript. Le projet permet d'explorer un catalogue de Pokémon à partir de données récupérées depuis une API, avec recherche, filtres, pagination, fiches détaillées et exploration des évolutions."
    },
];

    const goals = [
    'Évoluer vers un poste de Développeur Fullstack ou Frontend',
    'Participer à des projets web professionnels',
    'Approfondir mes compétences en développement Fullstack',
    'Contribuer à des applications modernes et utilisées par les utilisateurs',
];

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            width: '100%',
            margin: 0,
            padding: 0,
            boxSizing: 'border-box',
            backgroundColor: '#0f2027',
            backgroundImage: 'linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)',
            color: '#ffffff',
            fontFamily: "'Poppins', sans-serif",
            overflowX: 'hidden'
        }}>
            <Header />

            <main style={{
                flex: 1,
                padding: 'clamp(90px, 12vw, 140px) 16px 60px',
                maxWidth: '1000px',
                margin: '0 auto',
                width: '100%',
                boxSizing: 'border-box',
                backgroundColor: 'transparent'
            }}>
                {/* En-tête de page */}
                <div style={{ textAlign: 'center', marginBottom: 'clamp(40px, 8vw, 70px)' }}>
                    <h1 
					style={{
                fontSize: "42px",
                fontWeight: 800,
                letterSpacing: "-1px",
                marginBottom: "15px",
                background: "linear-gradient(90deg, #ffffff, #ffd700)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                marginTop: 0,
              }}
					>
                        À propos de moi
                    </h1>
                    <p style={{
                        color: '#cbd5e1',
                        fontSize: 'clamp(0.95rem, 2vw, 1.125rem)',
                        fontWeight: 400,
                        maxWidth: '600px',
                        margin: '0 auto',
                        lineHeight: 1.6
                    }}>
                        Découvrez ma philosophie, mes objectifs et mes compétences techniques
                    </p>
                    <div style={{
                        width: '80px',
                        height: '4px',
                        background: 'linear-gradient(90deg, #ffd700, #1766ad)',
                        margin: '25px auto 0',
                        borderRadius: '2px'
                    }} />
                </div>

                {/* 1. Présentation & Recherche */}
                <section style={{
                    backgroundColor: '#12222d',
                    border: '1px solid rgba(255, 255, 255, 0.15)',
                    borderRadius: '20px',
                    padding: 'clamp(20px, 4vw, 35px)',
                    marginBottom: '40px',
                    boxShadow: '0 15px 35px rgba(0, 0, 0, 0.4)',
                    position: 'relative',
                    overflow: 'hidden'
                }}>
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        bottom: 0,
                        width: '5px',
                        background: 'linear-gradient(180deg, #ffd700, #1766ad)'
                    }} />
                    <p style={{
                        lineHeight: 1.8,
                        color: '#f1f5f9',
                        fontSize: 'clamp(15px, 2.5vw, 17px)',
                        marginBottom: '20px'
                    }}>
                        Je suis développeur Fullstack Junior spécialisé dans le développement d'applications web modernes. Après avoir suivi une formation en développement web, j'ai choisi de me spécialiser dans l'écosystème JavaScript avec <strong style={{ color: '#ffd700' }}>React, Node.js, Express et MongoDB</strong>.
                    </p>
                    <p style={{
                        lineHeight: 1.8,
                        color: '#f1f5f9',
                        fontSize: 'clamp(15px, 2.5vw, 17px)',
                        marginBottom: '25px'
                    }}>
                        J'apprécie particulièrement la conception d'applications complètes, de l'interface utilisateur jusqu'aux API et à la base de données, avec un fort attrait pour la résolution de problèmes techniques et la création d'expériences fluides.
                    </p>
                    <div style={{
                        backgroundColor: '#1a313f',
                        padding: 'clamp(16px, 3vw, 20px)',
                        borderRadius: '12px',
                        border: '1px solid #ffd700',
                        color: '#ffd700',
                        fontSize: 'clamp(14.5px, 2vw, 16px)',
                        fontWeight: 500,
                        lineHeight: 1.6
                    }}>
                        🎯 <strong>Ce que je recherche :</strong> Un poste de Développeur Fullstack ou Frontend, en télétravail afin de participer à des projets professionnels, développer mes compétences auprès d'une équipe expérimentée et contribuer à la réalisation d'applications web modernes.
                    </div>
                </section>

                {/* Mes domaines de compétences */}
                <section style={{ marginBottom: '40px' }}>
                    <h2 style={{
                        color: '#ffd700',
                        fontSize: 'clamp(1.3rem, 3.5vw, 1.6rem)',
                        fontWeight: 700,
                        marginBottom: '25px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px'
                    }}>
                        <span>💻</span> Mes domaines de compétences
                    </h2>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 200px), 1fr))',
                        gap: '20px'
                    }}>
                        {skillCategories.map((cat, idx) => (
                            <div key={idx} style={{
                                padding: '25px',
                                borderRadius: '16px',
                                backgroundColor: '#12222d',
                                border: '1px solid rgba(255, 255, 255, 0.12)'
                            }}>
                                <h3 style={{
                                    color: '#ffd700',
                                    fontSize: '18px',
                                    marginBottom: '15px',
                                    fontWeight: 600
                                }}>
                                    {cat.title}
                                </h3>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                    {cat.skills.map((skill, sIdx) => (
                                        <span key={sIdx} style={{
                                            color: '#e2e8f0',
                                            fontSize: '15px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px'
                                        }}>
                                            <span style={{ color: '#ffd700', fontSize: '12px' }}>▪</span> {skill}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Mes technologies (Badges) */}
                <section style={{ marginBottom: '40px' }}>
                    <h2 style={{
                        color: '#ffd700',
                        fontSize: 'clamp(1.3rem, 3.5vw, 1.6rem)',
                        fontWeight: 700,
                        marginBottom: '25px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px'
                    }}>
                        <span>⚡</span> Technologies maîtrisées
                    </h2>
                    <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                        {allTechnologies.map((tech) => (
                            <div key={tech} style={{
                                padding: '8px 16px',
                                borderRadius: '30px',
                                backgroundColor: '#1a313f',
                                border: '1px solid #ffd700',
                                color: '#ffd700',
                                fontSize: 'clamp(13px, 2vw, 14px)',
                                fontWeight: 500
                            }}>
                                {tech}
                            </div>
                        ))}
                    </div>
                </section>

                {/* Ma manière de travailler (Workflow) */}
                <section style={{ marginBottom: '40px' }}>
                    <h2 style={{
                        color: '#ffd700',
                        fontSize: 'clamp(1.3rem, 3.5vw, 1.6rem)',
                        fontWeight: 700,
                        marginBottom: '25px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px'
                    }}>
                        <span>🔄</span> Ma manière de travailler
                    </h2>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 220px), 1fr))',
                        gap: '15px'
                    }}>
                        {workflowSteps.map((step, idx) => (
                            <div key={idx} style={{
                                padding: '16px 20px',
                                borderRadius: '12px',
                                backgroundColor: '#12222d',
                                border: '1px solid rgba(255, 255, 255, 0.1)',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '18px'
                            }}>
                                <span style={{
                                    color: '#ffd700',
                                    fontWeight: 800,
                                    fontSize: '18px',
                                    backgroundColor: '#1a313f',
                                    padding: '8px 12px',
                                    borderRadius: '8px'
                                }}>
                                    0{idx + 1}
                                </span>
                                <span style={{ color: '#f1f5f9', fontSize: '15px', fontWeight: 500 }}>
                                    {step}
                                </span>
                            </div>
                        ))}
                    </div>
                </section>

                {/* Philosophie & Apports */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 300px), 1fr))',
                    gap: '30px',
                    marginBottom: '40px'
                }}>
                    <section>
                        <h2 style={{
                            color: '#ffd700',
                            fontSize: 'clamp(1.15rem, 3vw, 1.35rem)',
                            fontWeight: 700,
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px'
                        }}>
                            <span>💡</span> Philosophie
                        </h2>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            {[
                                'Écrire un code maintenable',
                                'Privilégier une architecture claire',
                                'Développer des interfaces intuitives',
                                'Penser aux performances',
                                'Sécuriser les API',
                            ].map((item, idx) => (
                                <div key={idx} style={{
                                    padding: '15px 20px',
                                    backgroundColor: '#12222d',
                                    borderLeft: '4px solid #ffd700',
                                    borderRadius: '0 10px 10px 0',
                                    color: '#e2e8f0',
                                    fontSize: '15px'
                                }}>
                                    {item}
                                </div>
                            ))}
                        </div>
                    </section>

                    <section>
                        <h2 style={{
                            color: '#ffd700',
                            fontSize: 'clamp(1.15rem, 3vw, 1.35rem)',
                            fontWeight: 700,
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px'
                        }}>
                            <span>🚀</span> Mes apports
                        </h2>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            {contributions.map((item, idx) => (
                                <div key={idx} style={{
                                    padding: '15px 20px',
                                    borderRadius: '10px',
                                    backgroundColor: '#12222d',
                                    border: '1px solid rgba(255, 255, 255, 0.1)',
                                    color: '#e2e8f0',
                                    fontSize: '15px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px'
                                }}>
                                    <span style={{ color: '#ffd700', fontWeight: 'bold' }}>✓</span> {item}
                                </div>
                            ))}
                        </div>
                    </section>
                </div>

                {/* Projet phare & Objectifs */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 300px), 1fr))',
                    gap: '30px'
                }}>
                    <section>
                        <h2 style={{
                            color: '#ffd700',
                            fontSize: 'clamp(1.15rem, 3vw, 1.35rem)',
                            fontWeight: 700,
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px'
                        }}>
                            <span>📂</span> Projet phare
                        </h2>
                        {mainProjects.map((project, idx) => (
                            <div key={idx} style={{
                                padding: '25px',
                                borderRadius: '16px',
                                backgroundColor: '#12222d',
                                border: '1px solid #ffd700',
                                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)'
                            }}>
                                <h3 style={{
                                    color: '#ffd700',
                                    fontSize: '20px',
                                    marginBottom: '12px',
                                    fontWeight: 700
                                }}>
                                    {project.name}
                                </h3>
                                <p style={{
                                    color: '#e2e8f0',
                                    fontSize: '15px',
                                    lineHeight: 1.7,
                                    margin: 0
                                }}>
                                    {project.desc}
                                </p>
                            </div>
                        ))}
                    </section>

                    <section>
                        <h2 style={{
                            color: '#ffd700',
                            fontSize: 'clamp(1.15rem, 3vw, 1.35rem)',
                            fontWeight: 700,
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px'
                        }}>
                            <span>🎯</span> Mes objectifs
                        </h2>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            {goals.map((goal, idx) => (
                                <div key={idx} style={{
                                    padding: '15px 20px',
                                    borderRadius: '10px',
                                    backgroundColor: '#12222d',
                                    borderLeft: '4px solid #1766ad',
                                    color: '#e2e8f0',
                                    fontSize: '15px'
                                }}>
                                    {goal}
                                </div>
                            ))}
                        </div>
                    </section>
                </div>
            </main>
        </div>
    );
};

export default APropos;